import { TransactionTypeEnum } from "../../enum/transaction-type-enum";

export const colorByTransactionType = (transactionType: TransactionTypeEnum) => {
    switch(transactionType){
        case TransactionTypeEnum.Compra:
            return "success"
        case TransactionTypeEnum.Venda:
            return "error"
    }
};

export const colorByValue = (value: number) => {
    if (value >= 0) {
        return "success";
    }
    return "error";
}